"use client";

import { useEffect } from "react";
import * as CookieConsent from "vanilla-cookieconsent";

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: (...args: any[]) => void;
  }
}

export default function CookieConsentComponent() {
  useEffect(() => {
    // Bootstrap dataLayer + GTM start event
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];

      // Required GTM bootstrap event
      window.dataLayer.push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
      });

      // Debug consent (always granted for now)
      window.dataLayer.push({
        event: "default_consent",
        ad_storage: "granted",
        analytics_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
      });
    }

    const loadGTM = () => {
      window.dataLayer = window.dataLayer || [];
      if (document.getElementById("gtm-script")) return;

      const script = document.createElement("script");
      script.id = "gtm-script";
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtm.js?id=GTM-KQM4HPB6";
      document.head.appendChild(script);
    };

    const loadMetaPixel = () => {
      if (typeof window === "undefined") return;
      if ((window as any).fbq) return;

      const w = window as any;
      const d = document;

      w.fbq = function (...args: any[]) {
        if (w.fbq.callMethod) {
          w.fbq.callMethod.apply(w.fbq, args);
        } else {
          w.fbq.queue.push(args);
        }
      };

      if (!w._fbq) w._fbq = w.fbq;

      w.fbq.push = w.fbq;
      w.fbq.loaded = true;
      w.fbq.version = "2.0";
      w.fbq.queue = [];

      const script = d.createElement("script");
      script.async = true;
      script.src = "https://connect.facebook.net/en_US/fbevents.js";

      const firstScript = d.getElementsByTagName("script")[0];
      firstScript.parentNode?.insertBefore(script, firstScript);

      script.onload = () => {
        w.fbq("init", "1561458935203512");
        w.fbq("track", "PageView");
      };
    };

    CookieConsent.run({
      guiOptions: {
        consentModal: {
          layout: "bar",
          position: "bottom",
          equalWeightButtons: false,
          flipButtons: false,
        },
        preferencesModal: {
          layout: "box",
        },
      },

      categories: {
        necessary: {
          enabled: true,
          readOnly: true,
        },
        analytics: {},
        marketing: {},
      },

      language: {
        default: "sk",
        translations: {
          sk: {
            consentModal: {
              title: "Používame cookies",
              description: "Používame cookies na zlepšenie vášho zážitku.",
              acceptAllBtn: "Prijať všetko",
              acceptNecessaryBtn: "Len nevyhnutné",
              showPreferencesBtn: "Nastavenia",
            },
            preferencesModal: {
              title: "Nastavenia cookies",
              acceptAllBtn: "Prijať všetko",
              acceptNecessaryBtn: "Len nevyhnutné",
              savePreferencesBtn: "Uložiť",
              sections: [
                {
                  title: "Nevyhnutné",
                  description:
                    "Tieto cookies sú potrebné pre fungovanie stránky.",
                  linkedCategory: "necessary",
                },
                {
                  title: "Analytické",
                  description:
                    "Pomáhajú nám zlepšovať stránku pomocou štatistík.",
                  linkedCategory: "analytics",
                },
                {
                  title: "Marketingové",
                  description:
                    "Používajú sa na zobrazovanie relevantných reklám.",
                  linkedCategory: "marketing",
                },
              ],
            },
          },
        },
      },

      onConsent: () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "update_consent",
          analytics_storage: "granted",
          ad_storage: "granted",
          ad_user_data: "granted",
          ad_personalization: "granted",
        });
      },
    });

    // Always load everything (temporary mode)
    loadGTM();
    loadMetaPixel();
  }, []);

  return null;
}
